/* eslint-disable-next-line no-restricted-imports */
import { setEnvironment } from "./lib/stores/environment";

// We set the provider variables first, so that everything in the app is using them right from the start
setEnvironment({
  getFoojiDomain: () => import.meta.env.FOOJI_DOMAIN as string,
  getBugsnagApiKey: () => import.meta.env.FOOJI_BUGSNAG_API_KEY as string,
  getBusgnagStage: () => import.meta.env.FOOJI_NODE_ENV as string,
  getFoojiMicrositeDomain: () => document.location.host
});

// Ther we actually import the app, which loads the dependency tree
void import("./app");
